import { createStore } from 'vuex';

export default createStore({

    state: {
        currentAge: null,
        annualPayment: null,
        paymentYears: null,
        targetAge: null,
        targetReturnValue: null,
        result: null,
      },
      mutations: {
        setCurrentAge(state, age) {
          state.currentAge = age;
        },
        setAnnualPayment(state, payment) {
          state.annualPayment = payment;
        },
        setPaymentYears(state, years) {
          state.paymentYears = years;
        },
        setTargetAge(state, age) {
          state.targetAge = age;
        },
        setTargetReturnValue(state, value) {
          state.targetReturnValue = value;
        },
        setResult(state, result) {
          state.result = result;
        },
      },

  actions: {

    // uploadRecordsAction(context, payload) {
    //   context.commit('uploadRecords', payload)
    // },

  },

});